import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <div className="container footer-content max-width">
        {/* Company Info */}
        <div className="footer-column company-info" id="footer-logo">
          <Link to="/">
            <img
              src="/img/UBLong.svg"
              alt="UnsupervisedBias"
              className="nav-logo"
              style={{
                transition: 'all 0.3s ease',
                filter: 'drop-shadow(0 0 0px transparent)'
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'scale(1.03)';
                e.target.style.filter = 'drop-shadow(0 0 10px rgba(216, 134, 255, 0.8))';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'scale(1)';
                e.target.style.filter = 'drop-shadow(0 0 0px transparent)';
              }}
            />
          </Link>
          <p>Modern web solutions powered by AI and data science.</p>
          <div className="social-media">
            <a href="https://www.instagram.com/unsupervisedbias" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.youtube.com/channel/UCl_JLWs8XYCElgYQVnS9MqQ" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <i className="fab fa-youtube"></i>
            </a>
            <a href="https://www.linkedin.com/company/unsupervisedbias" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <i className="fab fa-linkedin"></i>
            </a>
          </div>
        </div>

        {/* Nav columns grouped — stays as row on mobile */}
        <div className="footer-links-group">

        {/* Browse Links */}
        <div className="footer-column browse">
          <div className="column-title">Browse</div>
          <ul className="footer-nav" id="browse">
            <li><Link to="/about">About</Link></li>
            {/* <li><Link to="/blog">Blog</Link></li> */}
            <li><Link to="/faq">FAQ</Link></li>
          </ul>
        </div>

        {/* Projects Links */}
        <div className="footer-column services">
          <div className="column-title">Projects</div>
          <ul className="footer-nav">
            <li><a href="https://pdubfantasy.com" target="_blank" rel="noopener noreferrer">PdubFantasy</a></li>
            <li><Link to="/2026RecessionMonitoring">Recession Monitor</Link></li>
          </ul>
        </div>

        {/* Contact Section */}
        <div id="contact-section" className="footer-column">
          <div className="column-title"><Link to="/contact">Contact</Link></div>
          <ul className="footer-nav">
            <li><i className="fas fa-map-marker-alt" style={{ marginRight: '6px', opacity: 0.5 }}></i>Washington, DC</li>
            <li><i className="fas fa-phone" style={{ marginRight: '6px', opacity: 0.5 }}></i><Link to="/contact">Book a Call</Link></li>
            <li><i className="fas fa-envelope" style={{ marginRight: '6px', opacity: 0.5 }}></i><a href="mailto:support@unsupervisedbias.com">Email Us</a></li>
          </ul>
        </div>
        </div>{/* /footer-links-group */}
      </div>

      {/* Copyright */}
      <div className="container" id="copyright">
        <div className="flex-item full-sentence">© {currentYear} UnsupervisedBias. All rights reserved.</div>
        <div className="flex-item policies">
          <Link to="/privacy-policy">Privacy Policy</Link> | <Link to="/terms-of-service">Terms of Service</Link> | <Link to="/dmca">DMCA</Link>
        </div>
      </div>

      {/* Fixed icons stack in Bottom Left */}
      <Link to="/camels" style={{ position: 'fixed', bottom: '89px', left: '10px', zIndex: 1000 }}>
        <img
          src="/img/camels_circle.png"
          alt="Camels Hockey"
          title="Camels Hockey"
          style={{
            width: '36px',
            height: '36px',
            transition: 'all 0.3s ease',
            filter: 'drop-shadow(0 0 0px transparent)'
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'scale(1.10)';
            e.target.style.filter = 'drop-shadow(0 0 8px rgba(232, 119, 34, 0.9))';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'scale(1)';
            e.target.style.filter = 'drop-shadow(0 0 0px transparent)';
          }}
        />
      </Link>
      <Link to="/wharf" style={{ position: 'fixed', bottom: '47px', left: '10px', zIndex: 1000 }}>
        <img
          src="/img/wharf_circle.png"
          alt="Wharf Hockey"
          title="Wharf Hockey"
          style={{
            width: '36px',
            height: '36px',
            transition: 'all 0.3s ease',
            filter: 'drop-shadow(0 0 0px transparent)'
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'scale(1.10)';
            e.target.style.filter = 'drop-shadow(0 0 8px rgba(74, 127, 165, 0.9))';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'scale(1)';
            e.target.style.filter = 'drop-shadow(0 0 0px transparent)';
          }}
        />
      </Link>
      <Link to="/" style={{ position: 'fixed', bottom: '5px', left: '10px', zIndex: 1000 }}>
        <img
          src="/img/UB_circle.svg"
          alt="UnsupervisedBias"
          style={{
            width: '36px',
            height: 'auto',
            transition: 'all 0.3s ease',
            filter: 'drop-shadow(0 0 0px transparent)'
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'scale(1.03)';
            e.target.style.filter = 'drop-shadow(0 0 10px rgba(216, 134, 255, 0.8))';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'scale(1)';
            e.target.style.filter = 'drop-shadow(0 0 0px transparent)';
          }}
        />
      </Link>
    </footer>
  );
};

export default Footer;
